/* Flaire landing pages v2 */
(function () {
  'use strict';
  var root = document.querySelector('.lp2'); if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || root).querySelectorAll(s)); };
  var D = JSON.parse($('#lp2-data').textContent);
  var V = D.variants, CFG = D.cfg || {};

  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || D.cur || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100).replace(/\.00$/, ''); }
    catch (e) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  }
  function short(v) { return String(v).replace(/ Inches/i, '″').replace(/ Inch/i, '″'); }

  /* ---------- variant state, shared by every buy box and the sticky bar ---------- */
  var STICK = $('[data-lp2-stick]'), NOTE = '';
  var nOpt = V.length ? V[0].o.length : 0, sel = [];
  function find(s) { for (var i = 0; i < V.length; i++) { var ok = true; for (var k = 0; k < nOpt; k++) if (V[i].o[k] !== s[k]) { ok = false; break; } if (ok) return V[i]; } return null; }
  (function initial() {
    var want = CFG.def || [], v = want.length ? find(want) : null;
    if (!v || !v.a) { for (var i = 0; i < V.length; i++) if (V[i].a) { v = V[i]; if (!want.length) break; var sc = 0; for (var k = 0; k < nOpt; k++) if (V[i].o[k] === want[k]) sc++; if (sc >= nOpt - 1) break; } }
    sel = (v || V[0]).o.slice();
  })();
  function availableWith(k, val) { var s = sel.slice(); s[k] = val; var v = find(s); return !!(v && v.a); }
  function paint() {
    var v = find(sel), ok = !!(v && v.a);
    $$('[data-lp2-buy]').forEach(function (box) {
      $$('.lp2-opt', box).forEach(function (fs) {
        var k = +fs.getAttribute('data-opt'); var cur = $('[data-cur]', fs); if (cur) cur.textContent = short(sel[k]);
        $$('.lp2-pill', fs).forEach(function (b) {
          var val = b.getAttribute('data-val');
          b.classList.toggle('on', val === sel[k]); b.classList.toggle('off', !availableWith(k, val));
          b.setAttribute('aria-pressed', val === sel[k] ? 'true' : 'false');
        });
      });
      var pr = $('[data-price]', box), cp = $('[data-cmp]', box), sv = $('[data-save]', box), bt = $('[data-add]', box);
      if (v) { pr.textContent = money(v.p); var has = v.c > v.p; cp.textContent = has ? money(v.c) : ''; cp.style.display = has ? '' : 'none'; sv.textContent = has ? 'Save ' + Math.round((1 - v.p / v.c) * 100) + '%' : ''; sv.style.display = has ? '' : 'none'; }
      bt.disabled = !ok; bt.textContent = ok ? bt.getAttribute('data-label') : 'Sold out in this size';
      var m = $('[data-msg]', box); if (m) m.textContent = ok ? NOTE : 'That combination is sold out. Pick another length or width.';
    });
    var st = STICK;
    if (st) { $('[data-s-size]', st).textContent = sel.map(short).join(' · ') + (v ? '  —  ' + money(v.p) : ''); var sb = $('[data-s-add]', st); sb.disabled = !ok; sb.textContent = ok ? 'Add to cart' : 'Sold out'; }
  }
  $$('.lp2-pill').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = +b.closest('.lp2-opt').getAttribute('data-opt'); sel[k] = b.getAttribute('data-val');
      if (!(find(sel) || {}).a) {
        /* that exact combination is sold out: keep what was tapped, move the other option to its nearest available value */
        var ord = []; for (var j = 0; j < nOpt; j++) { ord[j] = []; V.forEach(function (x) { if (ord[j].indexOf(x.o[j]) < 0) ord[j].push(x.o[j]); }); }
        var best = null, bestD = 1e9;
        V.forEach(function (x) { if (!x.a || x.o[k] !== sel[k]) return; var d = 0; for (var j = 0; j < nOpt; j++) d += Math.abs(ord[j].indexOf(x.o[j]) - ord[j].indexOf(sel[j])); if (d < bestD) { bestD = d; best = x; } });
        if (best) { sel = best.o.slice(); NOTE = 'That exact size is sold out, so we moved you to the closest one in stock.'; }
      } else NOTE = '';
      paint();
    });
  });
  /* best-seller tags, from sales data baked into the page config */
  $$('.lp2-pill').forEach(function (b) { var t = (CFG.tags || {})[b.getAttribute('data-val')]; if (t) { var i = document.createElement('i'); i.textContent = t; b.appendChild(i); } });

  function openCart() { try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; } } catch (e) {} location.href = '/cart'; }
  var busy = false;
  function add(btn) {
    var v = find(sel); if (!v || !v.a || busy) return; busy = true;
    var was = btn.textContent; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) { if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || 'Could not add'); btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = was; busy = false; }, 1400); openCart(); })
      .catch(function (e) { busy = false; btn.textContent = was; $$('[data-msg]').forEach(function (m) { m.textContent = e.message || 'Something went wrong, please try again.'; }); });
  }
  $$('[data-add],[data-s-add]').forEach(function (b) { b.addEventListener('click', function () { add(b); }); });
  window.lp2Add = function () { add($('[data-add]')); };

  /* ---------- sticky bar: on from the first screen on phones; hides only while a buy button is on screen ---------- */
  var stick = STICK;
  if (stick) {
    document.body.appendChild(stick);
    var adds = $$('[data-add]');
    var sync = function () {
      var vis = adds.some(function (a) { var r = a.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight - 70; });
      stick.classList.toggle('hide', vis);
    };
    addEventListener('scroll', sync, { passive: true }); addEventListener('resize', sync); sync();
    $('.t', stick).addEventListener('click', function () { var b = $('[data-lp2-buy]'); b.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  }
  $$('[data-goto]').forEach(function (a) { a.addEventListener('click', function (e) { var t = $(a.getAttribute('data-goto')); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }); });

  /* ---------- gallery ---------- */
  $$('[data-gal]').forEach(function (g) {
    var track = $('.lp2-track', g), th = $$('.lp2-thumbs button', g);
    th.forEach(function (b, i) { b.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }); });
    var on = function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); th.forEach(function (b, k) { b.classList.toggle('on', k === i); }); };
    track.addEventListener('scroll', on, { passive: true }); on();
  });

  /* ---------- video reel: load on approach, play the one in view, tap for sound ---------- */
  var vids = $$('.lp2-vid');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = $('video', e.target); if (!v) return;
        if (e.isIntersecting && e.intersectionRatio > .6) { if (!v.src) v.src = v.getAttribute('data-src'); v.play().catch(function () {}); }
        else { try { v.pause(); } catch (x) {} }
      });
    }, { threshold: [0, .6, 1] });
    vids.forEach(function (c) {
      io.observe(c);
      c.addEventListener('click', function () {
        var v = $('video', c); if (!v.src) v.src = v.getAttribute('data-src');
        vids.forEach(function (o) { if (o !== c) { var ov = $('video', o); ov.muted = true; $('em', o).textContent = '🔇'; } });
        v.muted = !v.muted; $('em', c).textContent = v.muted ? '🔇' : '🔊'; v.play().catch(function () {});
      });
    });
  }

  /* ---------- reviews ---------- */
  var R = D.reviews || [], rbox = $('[data-rgrid]');
  if (rbox) {
    var shown = 0, PAGE = innerWidth < 700 ? 6 : 9, filter = 0, more = $('[data-rmore]');
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
    var stars = function (n) { return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); };
    var fmt = function (d) { try { return new Date(d + 'T00:00:00').toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return d; } };
    var list = function () { return filter ? R.filter(function (r) { return r.r === filter; }) : R; };
    var card = function (r, idx) {
      var ph = (r.ph || []).map(function (u, i) { return '<button type="button" data-ph="' + idx + ':' + i + '" aria-label="Open buyer photo"><img loading="lazy" src="' + u + '&width=440" alt="Photo from ' + esc(r.n) + '"></button>'; }).join('');
      return '<article class="lp2-rv"><div class="lp2-rv-top"><span class="lp2-av">' + esc((r.n || 'V').charAt(0).toUpperCase()) + '</span><div><b>' + esc(r.n) + '</b><small><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11"/><path d="M10.6 16.2l-3.7-3.7 1.5-1.5 2.2 2.2 5-5 1.5 1.5z" fill="#fff"/></svg>Verified buyer</small></div></div>' +
        '<div class="lp2-rv-meta"><span class="lp2-stars" aria-label="' + r.r + ' out of 5">' + stars(r.r) + '</span><time>' + fmt(r.d) + '</time></div>' +
        (r.t && r.b.toLowerCase().indexOf(r.t.toLowerCase().replace(/\u2026|\.\.\.$/,'').slice(0,18)) !== 0 ? '<h4>' + esc(r.t) + '</h4>' : '') + '<p>' + esc(r.b) + '</p>' + (ph ? '<div class="lp2-rv-ph">' + ph + '</div>' : '') +
        '<div class="lp2-rv-pr">Bought: ' + esc(r.p) + '</div></article>';
    };
    var draw = function (reset) {
      var L = list(); if (reset) { rbox.innerHTML = ''; shown = 0; }
      var next = L.slice(shown, shown + PAGE); rbox.insertAdjacentHTML('beforeend', next.map(function (r) { return card(r, R.indexOf(r)); }).join('')); shown += next.length;
      if (more) { more.style.display = shown < L.length ? '' : 'none'; more.textContent = 'Show more reviews (' + (L.length - shown) + ')'; }
    };
    draw(true);
    if (more) more.addEventListener('click', function () { draw(false); });
    $$('[data-rbar]').forEach(function (b) { b.addEventListener('click', function () { var n = +b.getAttribute('data-rbar'); filter = filter === n ? 0 : n; $$('[data-rbar]').forEach(function (o) { o.classList.toggle('on', +o.getAttribute('data-rbar') === filter); }); draw(true); }); });
    var lb = $('[data-lb]');
    if (lb) {
      document.body.appendChild(lb);
      var openLb = function (u, r) { lb.querySelector('img').src = u + '&width=1024'; lb.querySelector('p').textContent = '“' + r.b + '”  — ' + r.n + ', ' + r.p; lb.classList.add('on'); };
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ph]'); if (!b) return; var a = b.getAttribute('data-ph').split(':'), r = a[0] === 'x' ? (D.photos || [])[+a[1]] : R[+a[0]];
        if (!r) return; openLb(a[0] === 'x' ? r.u : r.ph[+a[1]], r);
      });
      lb.addEventListener('click', function () { lb.classList.remove('on'); });
    }
  }
  paint();
})();
